{
  "expo": {
    "name": "Helm",
    "slug": "fxm-mobile",
    "version": "1.0.0",
    "orientation": "portrait",
    "icon": "./assets/icon.png",
    "userInterfaceStyle": "automatic",
    "runtimeVersion": {
      "policy": "appVersion"
    },
    "updates": {
      "url": "https://u.expo.dev/b4f79ce5-1883-48b1-be33-1696b53ec0ac"
    },
    "ios": {
      "supportsTablet": true,
      "bundleIdentifier": "ai.getfxm.helm"
    },
    "android": {
      "package": "ai.getfxm.helm",
      "adaptiveIcon": {
        "backgroundColor": "#E6F4FE",
        "foregroundImage": "./assets/android-icon-foreground.png",
        "backgroundImage": "./assets/android-icon-background.png",
        "monochromeImage": "./assets/android-icon-monochrome.png"
      },
      "predictiveBackGestureEnabled": false,
      "permissions": [
        "android.permission.RECORD_AUDIO"
      ]
    },
    "web": {
      "favicon": "./assets/favicon.png"
    },
    "plugins": [
      "expo-secure-store",
      [
        "expo-image-picker",
        {
          "photosPermission": "Allow $(PRODUCT_NAME) to attach photos to your messages."
        }
      ],
      "expo-status-bar",
      "expo-sharing"
    ],
    "extra": {
      "eas": {
        "projectId": "b4f79ce5-1883-48b1-be33-1696b53ec0ac"
      }
    }
  }
}
